;(function(EG) {
  'use strict';

  var cdfListTempl, cdfTextTempl, cdfUtils, companyCDFs;

  cdfTextTempl = Handlebars.templates['partials/common/user_self_registration/user_business_info/cdf/cdf-text'];
  cdfListTempl = Handlebars.templates['partials/common/user_self_registration/user_business_info/cdf/cdf-list'];
  cdfUtils = EG.Users.Utils.CustomDataFields;
  companyCDFs = [];

  function renderCDF(options) {
    var renderFn;

    renderFn = renderCDFTextField;

    if (cdfUtils.isCDFListField(options.cdf)) {
      renderFn = renderCDFListField;
    }

    renderFn({
      cdf: options.cdf,
      $container: options.$container,
      onRender: options.onRender
    });
  }

  function renderCDFTextField(options) {
    var cdf, $cdf, templData;

    cdf = options.cdf;
    templData = {};

    templData.id = cdf.id;
    templData.label = cdf.name;
    templData.isMandatory = cdf.validations.mandatory;
    templData.attrs = 'minlength="' + cdf.validations.minLength + '"';
    templData.attrs += ' ';
    templData.attrs += 'maxlength="' + cdf.validations.maxLength + '"';

    options.$container.append(cdfTextTempl(templData));

    $cdf = options.$container.find('[data-id="' + templData.id + '"]');

    options.onRender(cdf, $cdf);
  }

  function renderCDFListField(options) {
    var templData, cdf, $cdf;

    templData = {};
    cdf = options.cdf;

    templData.id = cdf.id;
    templData.label = cdf.name;
    templData.isMandatory = cdf.validations.mandatory;

    options.$container.append(cdfListTempl(templData));

    $cdf = options.$container.find('[data-id="' + templData.id + '"]');

    fetchCDFListData(templData.id).then(
      function(collection) {
        var cdfData;

        cdfData = collection.toJSON();

        companyCDFs = companyCDFs.concat(cdfData);

        $cdf.removeAttr('disabled');
        $cdf.select2({
          placeholder: {
            id: '-1', // the value of the option
            text: uitk.i18n.msg('profile_please_select')
          },
          data: cdfData
        });
        options.onRender(cdf, $cdf);
      },
      function() {
        $cdf.html('<p>Cannot load CDF values</p>');
      }
    );
  }

  function fetchCDFListData(cdfId) {
    var cdfModel, companyId;

    companyId = EG.Users.Utils.getCompanyId();

    cdfModel = new EG.Users.Profile.Collections.CustomDataFields([], {
      code: cdfId,
      company: companyId
    });

    return cdfModel.fetchData();
  }

  function fetchCDFFormValues(cdfCollection) {
    var inputValues, cdfParseAttr;

    cdfParseAttr = {};
    cdfCollection.each(function(model) {
      var modelId;

      modelId = model.get('id');

      cdfParseAttr[modelId] = undefined;
    });

    inputValues = EG.Users.Utils.parseForm({
      formName: EG.Users.Profile.Constants.PROFILE_FORM_NAME,
      attributes: {
        cdf: cdfParseAttr
      },
      parsers: {
        default: EG.Users.Utils.parseDefaultFormAttributes
      }
    });

    return inputValues;
  }

  function setAndValidate(cdfCollection) {
    var isCollectionValid, cdfValues, cdfInfo;

    cdfValues = fetchCDFFormValues(cdfCollection);
    isCollectionValid = true;

    _.each(cdfValues.cdf, function(cdfValue, cdfId) {
      var cdfInfo, model, attrObj, key;

      model = cdfCollection.findModelById(cdfId);

      model.set(cdfId, cdfValue, {
        validate: true
      });

      if (!model.isValid()) {
        isCollectionValid = false;
        return;
      }

      cdfInfo = getCDFInfo(cdfValue);
      cdfInfo.id = parseInt(cdfId, 10);

      if (cdfInfo.label) {
        model.set('cdfInfo', cdfInfo);
      }
    });

    return isCollectionValid;
  }

  function getCDFInfo(cdfId) {
    var cdfInfo, cdfValues;

    cdfInfo = {};
    cdfValues = _.findWhere(companyCDFs, {
      id: parseInt(cdfId, 10)
    });

    if (cdfValues) {
      cdfInfo = {
        label: cdfValues.value
      };
    }

    if (!_.isEmpty(cdfId) && _.isUndefined(cdfValues)) {
      cdfInfo = {
        label: cdfId
      };
    }

    return cdfInfo;
  }

  function isCDFEnabled(templateConfig) {
    return (
      templateConfig.user_self_registration.enabled &&
      templateConfig.user_self_registration.user_business_info &&
      templateConfig.user_self_registration.user_business_info.enabled &&
      templateConfig.user_self_registration.user_business_info.user_custom_data_fields.enabled
    );
  }

  /**
   * Let the world know !
   */
  EG.Users.Profile.View.Utils.CustomDataFieldsV2 = {};
  EG.Users.Profile.View.Utils.CustomDataFieldsV2.renderCDF = renderCDF;
  EG.Users.Profile.View.Utils.CustomDataFieldsV2.renderCDFListField = renderCDFListField;
  EG.Users.Profile.View.Utils.CustomDataFieldsV2.fetchCDFFormValues = fetchCDFFormValues;
  EG.Users.Profile.View.Utils.CustomDataFieldsV2.setAndValidate = setAndValidate;
  EG.Users.Profile.View.Utils.CustomDataFieldsV2.isCDFEnabled = isCDFEnabled;
})(EG);
